import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { combineLatest, of, Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { CustomAddToCartService } from '../custom-add-to-cart/custom-add-to-cart.service';
import { LoactionStripService } from '../shared/modules/location-strip/loaction-strip.service';
import { SharedService } from '../shared/services/shared.service';

const CLIENT_NAME_FIELDS = [
  'companyName',
  'unitID',
  'line1',
  'line2',
  'town',
  'postalCode',
];

@Component({
  selector: 'app-change-location-modal',
  templateUrl: './change-location-modal.component.html',
  styleUrls: ['./change-location-modal.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangeLocationModalComponent implements OnInit, OnDestroy {
  readonly modal = inject(NgbModal);
  private readonly cartService = inject(CustomAddToCartService);
  private readonly locationStripService = inject(LoactionStripService);
  private readonly sharedService = inject(SharedService);

  private accountDetailsSub: Subscription;
  private cartItemsSub: Subscription;
  private getuserData: any;
  private cartId: string;
  private soldToAddress;
  private isDefaultAddressChecked: boolean;

  searchedClientList: any[];
  selectedData: any;
  hidemsg: boolean;
  shippingDefaultAddress;
  private saveSelectedShipToAddressSub: Subscription;

  ngOnInit(): void {
    this.accountDetailsSub = this.cartService.userAccountDetails$
      .pipe(filter(Boolean), take(1))
      .subscribe((userDataget: any) => {
        this.getuserData = userDataget.res.shippingAddresses;
        this.soldToAddress = userDataget.res.soldToAddress;
        this.searchedClientList = this.getuserData;

        this.shippingDefaultAddress = this.searchedClientList.find(
          (address) => !!address.defaultAddress
        );
      });

    this.cartItemsSub = this.cartService.cartItems$
      .pipe(filter(Boolean), take(1))
      .subscribe((cart: any) => {
        this.cartId = cart.code;
        this.selectedData = cart.childCarts.find(
          (el) => el.cartType === 'STANDARD'
        )?.shipToParty;
      });
  }

  onOptionsSelected(data: any): void {
    this.selectedData = data;
  }

  searchClientName(data: any): void {
    if (!data.length) {
      this.searchedClientList = this.getuserData;

      return;
    }

    this.searchedClientList = this.getuserData.filter((x) => {
      return CLIENT_NAME_FIELDS.some((field) => {
        return x[field]?.toLowerCase().includes(data.toLowerCase());
      });
    });
  }

  defaultCheck(event: any): void {
    this.isDefaultAddressChecked = event.target['checked'];
  }

  onSubmit(): void {
    const unitId = this.selectedData?.uid || this.selectedData?.unitID;

    if (this.cartId) {
      this.cartService.saveLocation(
        unitId,
        this.cartId,
        this.cartService.userId
      );
    }

    this.saveSelectedShipToAddressSub = combineLatest([
      this.locationStripService.saveSelectedAccount(
        this.cartService.userId,
        this.soldToAddress?.unitID
      ),
      this.locationStripService.saveSelectedShipToAddress(
        this.cartService.userId,
        unitId,
        !!this.isDefaultAddressChecked
      ),
      this.cartId ? this.cartService.changedLocation$ : of(true),
    ])
      .pipe(filter(Boolean))
      .subscribe(() => location.reload());
  }

  ngOnDestroy(): void {
    this.accountDetailsSub?.unsubscribe();
    this.cartItemsSub?.unsubscribe();
    this.saveSelectedShipToAddressSub?.unsubscribe();
  }
}
